import LessonCreatePage from "./LessonCreatePage";

export default LessonCreatePage;